export default __webpack_public_path__ + "static/clinica-rosario-5abe01c80a21ecc882cc5ce1ad00ecd4.jpg";